<template>
  <div class="inline-block lg:block mr-2 lg:leading-none mt-1">
    <div class="text-sm text-gray-700">{{ number }}</div>
  </div>
</template>

<script>
export default {
  name: 'RowNumber',
  props: {
    number: String
  }
};
</script>